import { render, staticRenderFns } from "./JsAppMain.vue?vue&type=template&id=56e51fd8"
import script from "./JsAppMain.vue?vue&type=script&lang=js"
export * from "./JsAppMain.vue?vue&type=script&lang=js"
import style0 from "./JsAppMain.vue?vue&type=style&index=0&id=56e51fd8&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56e51fd8')) {
      api.createRecord('56e51fd8', component.options)
    } else {
      api.reload('56e51fd8', component.options)
    }
    module.hot.accept("./JsAppMain.vue?vue&type=template&id=56e51fd8", function () {
      api.rerender('56e51fd8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/components/JsAppMain.vue"
export default component.exports